import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var Linkedin = function Linkedin(props) {
  useDeprecatedComponentWarning({
    component: 'Linkedin'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M43 725h426v1323H43V725zm1109 1323v-768q0-123 67.5-189.5T1389 1024q103 0 167.5 73.5T1621 1323v725h427v-768q0-282-141-439.5T1536 683q-122 0-219 61t-165 164l-14-183H718l7 299v1024h427zM254 512h-3q-111 0-181-67.5T0 277q0-101 71.5-167.5T258 43q113 0 182.5 66.5T512 277q0 101-71 168t-187 67z"
  }));
};

Linkedin.displayName = 'Linkedin';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Linkedin.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Linkedin;